export enum GetNPPESDataActionDispatchTypes {
  GET_NPPES_DATA_INVOKE = "GET_NPPES_DATA_INVOKE",
  GET_NPPES_DATA_SUCCESS = "GET_NPPES_DATA_SUCCESS",
  GET_NPPES_DATA_RESET = "GET_NPPES_DATA_RESET",
  GET_NPPES_DATA_ERROR = "GET_NPPES_DATA_ERROR",
}

export enum GetOrderingNPPESDataActionDispatchTypes {
  GET_ORDERING_NPPES_DATA_INVOKE = "GET_ORDERING_NPPES_DATA_INVOKE",
  GET_ORDERING_NPPES_DATA_SUCCESS = "GET_ORDERING_NPPES_DATA_SUCCESS",
  GET_ORDERING_NPPES_DATA_RESET = "GET_ORDERING_NPPES_DATA_RESET",
  GET_ORDERING_NPPES_DATA_ERROR = "GET_ORDERING_NPPES_DATA_ERROR",
}

export enum GetPrimaryNPPESDataActionDispatchTypes {
  GET_PRIMARY_NPPES_DATA_INVOKE = "GET_PRIMARY_NPPES_DATA_INVOKE",
  GET_PRIMARY_NPPES_DATA_SUCCESS = "GET_PRIMARY_NPPES_DATA_SUCCESS",
  GET_PRIMARY_NPPES_DATA_RESET = "GET_PRIMARY_NPPES_DATA_RESET",
  GET_PRIMARY_NPPES_DATA_ERROR = "GET_PRIMARY_NPPES_DATA_ERROR",
}